import Toast from "./Toast";

export default Toast


// WEBPACK FOOTER //
// ./src/components/toastComponent/index.ts